import { Component, signal, computed } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PrefixMockService } from '../../../core/services/prefix.service';
import { EmailService } from 'src/app/core/services/emailjs.service';
import { CommonModule } from '@angular/common';
import { take } from 'rxjs/operators';
import { Prefix } from 'src/app/core/models/DigitalKit';
import { toSignal } from '@angular/core/rxjs-interop';
import { TalentFormData } from 'src/app/core/models/DigitalKit';


@Component({
  selector: 'app-jobs-form',
  standalone: true,
  templateUrl: './jobs-form.component.html',
  styleUrls: ['./jobs-form.component.css'],
  imports: [ReactiveFormsModule, FormsModule, CommonModule]
})
export class JobsFormComponent {


  loading = signal(false);
  success = signal(false);
  error = signal(false);

  prefixes = signal<Prefix[]>([]);
  selectedTechnicalSectors = signal<string[]>([]);
  selectedContracts = signal<string[]>([]);
  sectorTouched = signal(false);
  touchedContracts = signal(false);


  sectors = [
    "Desarrollador Front-End",
    "Desarrollador Back-End",
    "Desarrollador Full-Stack",
    "Desarrollo Android / Apps",
    "Desarrollo iOS / Apps",
    "UX/UI Design",
    "Arquitecto/desarrollador Java",
    "Arquitecto/desarrollador Python",
    "Data Scientist",
    "Data Analyst",
    "Consultor Microsoft",
    "Comunicación / Marketing digital",
    "Jefe de proyecto TIC",
    "Product Owner",
    "Desarrollador junior (Front / Back)",
    "Otro"
  ];

  technicalSectors = [
    "Angular",
    "iOS",
    ".NET",
    "Python",
    "Java",
    "JavaScript",
    "Android",
    "PHP",
    "React",
    "Node.js",
    "Cloud: Azure, AWS",
    "Otro"
  ];

  contracts = [
    "Indefinido",
    "De duración determinada",
    "Freelance",
    "Prácticas",
    "Jornada completa",
    "Jornada a tiempo parcial",
    "Por horas"
  ];


  form = this.fb.nonNullable.group({
    name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],

    prefix: ['+34', Validators.required],
    phone: ['', [Validators.required, Validators.pattern(/^[0-9+\s-]{9,15}$/)]],

    experience: ['', [Validators.required, Validators.pattern(/^[0-9+\s-]{1,2}$/)]],
    linkedin: ['', Validators.required],

    sector: ['', Validators.required],
    otherSector: [''],

    otherTechnicalSector: [''],

    warning: [false, Validators.requiredTrue]
  });

  formValue = toSignal(this.form.valueChanges, { initialValue: this.form.value });


  constructor(
    private fb: FormBuilder,
    private prefixService: PrefixMockService,
    private emailService: EmailService
  ) {
    this.prefixService.getPrefixes().pipe(take(1)).subscribe(data => {
      this.prefixes.set(data);
    });
  }


  formReady = computed(() => {
    const f = this.formValue();

    if (this.form.invalid) return false;

    if (this.selectedTechnicalSectors().length === 0) return false;

    if (f.sector === "Otro" && !f.otherSector) return false;

    if (this.selectedTechnicalSectors().includes("Otro") && !f.otherTechnicalSector)
      return false;

    if (this.selectedContracts().length === 0) return false;

    return true;
  });



  toggleTechnicalSector(ev: Event, sector: string) {
    this.sectorTouched.set(true);
    const checked = (ev.target as HTMLInputElement).checked;
    const current = this.selectedTechnicalSectors();

    if (checked) {
      this.selectedTechnicalSectors.set([...current, sector]);
    } else {
      this.selectedTechnicalSectors.set(current.filter(s => s !== sector));

      if (sector === "Otro") {
        this.form.controls.otherTechnicalSector.setValue('');
      }
    }
  }

  toggleContract(ev: Event, contract: string) {
    this.touchedContracts.set(true);
    const checked = (ev.target as HTMLInputElement).checked;
    const current = this.selectedContracts();

    if (checked) {
      if (current.length < 3) {
        this.selectedContracts.set([...current, contract]);
      } else {
        (ev.target as HTMLInputElement).checked = false;
      }
    } else {
      this.selectedContracts.set(current.filter(c => c !== contract));
    }
  }



  onSubmit() {
    if (!this.formReady()) return;

    this.loading.set(true);
    this.error.set(false);
    this.success.set(false);

    const f = this.form.getRawValue();

    const data: TalentFormData = {
      name: f.name,
      email: f.email,
      phone: `${f.prefix} ${f.phone}`,
      experience: f.experience,
      linkedin: f.linkedin,
      sector: f.sector === "Otro" ? f.otherSector : f.sector,
      technicalSectors: this.selectedTechnicalSectors().join(', '),
      otherTechnicalSector: f.otherTechnicalSector || '',
      contracts: this.selectedContracts().join(', ')
    };

    this.emailService.sendTalentForm(data)
      .then(() => {

        this.success.set(true);

        this.form.reset({
          prefix: '+34',
          warning: false
        });

        this.selectedTechnicalSectors.set([]);
        this.selectedContracts.set([]);
        this.sectorTouched.set(false);
        this.touchedContracts.set(false);

        document
          .querySelectorAll<HTMLInputElement>('input[type="checkbox"]')
          .forEach(cb => cb.checked = false);

        setTimeout(() => {
          this.success.set(false);
        }, 5000);
      })
      .catch((err) => {
        console.error(err);

        this.error.set(true);

        setTimeout(() => {
          this.error.set(false);
        }, 5000);
      })
      .finally(() => {
        this.loading.set(false);
      });
  }
}
